module.exports = __webpack_public_path__ + "img/spin.f4404720.gif";